import Cookies from 'js-cookie'
import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
// import Layout from './views/layout/Layout'
// import { getToken } from '@/utils/auth' // getToken from cookie

NProgress.configure({ showSpinner: false })// NProgress Configuration

// const whiteList = ['/login']// no redirect whitelist
router.beforeEach((to, from, next) => {
  // console.log('routing')
  document.title = process.env.APP_NAME
  NProgress.start() // start progress bar

  // console.log('beforeRouteLeave', to, from)

  if (to.query) {
    switch (to.query.refresh) {
      case '1': {
        location.replace(to.fullPath.replace('refresh=1', 'refresh=0'))
        break
      }
      // case '2': {
      //   location.replace(to.fullPath.replace('refresh=2', 'refresh=0'))
      //   break
      // }
    }
  }

  // if (to.query.refresh === 'true') {
  // location.reload()
  // location.replace(to.fullPath.replace('refresh=true', 'refresh=false'))
  // next(to.fullPath.replace('refresh=true', 'refresh=false'))
  // next(to.path)
  // }

  if (localStorage[process.env.COOKIE]) {
    if (JSON.parse(localStorage[process.env.COOKIE]).user.token) { // determine if there has token
      /* has token*/
      if (to.path === '/login' || to.path === '/') {
        // console.log(to)
        // next({ path: store.getters.branchSelected ? '/dashboard' : '/projects' })
        // console.log(store.getters.features)
        // if (store.getters.features.accounting) {
        //   next({ path: '/accounting/general' })
        // } else if (store.getters.features.commercial) {
        //   next({ path: '/commercial/quotation' })
        // } else if (store.getters.features.sample) {
        //   next({ path: '/sample' })
        // } else {
        if (to.query.redirect) {
          next({ path: to.query.redirect })
        } else {
          const companies = store.getters.companies.sort((a, b) => {
            if (a.relationId && b.relationId) {
              if (a.relationId.name < b.relationId.name) {
                return -1
              }
              if (a.relationId.name > b.relationId.name) {
                return 1
              }
            }

            return 0
          })
          // console.log('companies', companies)
          // console.log('Cookies.get(\'branchSelected\')', Cookies.get('branchSelected'))
          // console.log('store.getters.branchSelected', store.getters.branchSelected)
          if (Cookies.get('branchSelected') && Cookies.get('branchSelected') !== 'null') {
            // console.log('cookie branch')
            next({ path: `/z/${Cookies.get('branchSelected')}/default` })
          } else if (companies.length > 0 && companies[0].relationId && companies[0].relationId.regions.length > 0 && companies[0].relationId.regions[0].branches.length > 0) {
            // console.log('first branch')
            // console.log('companies[0].relationId.regions[0].branches[0]', companies[0].relationId.regions[0].branches[0])
            next({ path: `/z/${companies[0].relationId.regions[0].branches[0]._id}/default` })
          } else {
            next({ path: '/account/profile' })
          }
        }
        // }
        NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
      } else {
        // console.log("store.getters.permission_routers", store.getters.permission_routers)
        if (!store.getters.permission_routers) {
          store.dispatch('GetInfo', to.path).then(res => { // user_info
            store.dispatch('GenerateRoutes', { relationRole: res.relationRole, role: res.role.type, confirmed: res.confirmed, awakRole: res.awakRole, userData: res.userData, companies: res.companies, features: res.features }).then(() => { // roles
              router.addRoutes(store.getters.addRouters)
              // console.log('...to', ...to)
              next({ ...to, replace: true }) // hack addRoutes ,set the replace: true so the navigation will not leave a history record
              // next()
            })
          }).catch((err) => {
            store.dispatch('FedLogOut').then(() => {
              Message.error(err || 'Verification failed, please login again')
              next({ path: '/' })
            })
          })
        } else {
          // if (router.options.routes.find(route => (route.path === '' && to.path === '/') || route.path === to.path)) {
          next()
          // } else {
          //   next('/')
          // }
        }
      }
    } else {
      /* has no token*/
      // check if route exists, if not, redirect to /404
      // console.log(router.options.routes)
      // console.log(to.path)
      // console.log(router.options.routes.find(route => (route.path === '' && to.path === '/') || route.path === to.path))
      if (to.path.substring(0, 3) === '/p/' || to.path.substring(0, 2) === '/a') {
        next()
        NProgress.done()
      } else if (router.options.routes.find(route => (route.path === '' && to.path === '/') || route.path === to.path)) {
        next()
        NProgress.done()
      } else {
        next(`/?redirect=${to.fullPath}`)
      }
    }
    // console.log(JSON.parse(localStorage[process.env.COOKIE]).user.token)
  } else {
    /* has no token*/
    if (to.path.substring(0, 3) === '/p/' || to.path.substring(0, 2) === '/a') {
      next()
      NProgress.done()
    } else if (router.options.routes.find(route => (route.path === '' && to.path === '/') || route.path === to.path)) {
      next()
      NProgress.done()
    } else {
      next(`/?redirect=${to.fullPath}`)
    }
  }
  // console.log(router.options.routes)
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js